export default __webpack_public_path__ + "static/media/team.4e02f604.png";